import { Controller } from "@hotwired/stimulus"
import { isHandheld } from "@/helpers/window_size"

const ACTIVE_CLASS = "--active"

export default class AccordionController extends Controller {
  static targets = ["item"]
  declare readonly itemTargets: HTMLElement[]

  static values = {
    autoCollapse: { type: Boolean, default: false }
  }
  declare readonly autoCollapseValue: boolean

  expand(item: HTMLElement): void {
    item.classList.add(ACTIVE_CLASS)
  }

  toggleItem(event: Event): void {
    if (this.clickOnInteractiveControl(event)) {
      return
    }

    const item = (event.currentTarget as HTMLElement).parentElement as HTMLElement

    if (this.autoCollapseValue) {
      this.itemTargets.forEach((other) => {
        if (other !== item) {
          this.collapse(other)
        }
      })

      if (isHandheld()) {
        item.scrollIntoView()
      }
    }

    this.toggleActive(item)
    event.stopPropagation()
  }

  expandAll(): void {
    this.itemTargets.forEach((item) => this.expand(item))
  }

  collapseAll(): void {
    this.itemTargets.forEach((item) => this.collapse(item))
  }

  private clickOnInteractiveControl(event: Event): boolean {
    const target = event.target as HTMLElement
    return !!target.closest('a, button, input[type="checkbox"], input[type="radio"]')
  }

  private collapse(item: HTMLElement): void {
    item.classList.remove(ACTIVE_CLASS)
  }

  private toggleActive(item: HTMLElement): void {
    item.classList.toggle(ACTIVE_CLASS)
  }
}
